require('angular')
require('../flash/flash-module')
require('../common-header/common-header-module') # TODO we may move common-header into common-wrapper
require('../common-footer/common-footer-module')
# Used for some screens. I don't know the rule about what kind of
# screen will use this type of wrapper. So I can't give it meaningful name.
CommonWrapperADirective = require('./common-wrapper-a-directive')
# Used for sign in, sign up and etc. I don't know the rule about what kind of
# screen will use this type of wrapper. So I can't give it meaningful name.
CommonWrapperBDirective = require('./common-wrapper-b-directive')

modules = [
  'gnp-flash'
  'gnp-common-header'
  'gnp-common-footer'
]
angular.module 'gnp-common-wrapper', modules
  .directive('gnpCommonWrapperA', CommonWrapperADirective)
  .directive('gnpCommonWrapperB', CommonWrapperBDirective)




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-wrapper/common-wrapper-module.coffee